<template>
  <div v-if="($canAccess(['agency', 'agency-employee', 'employee']) || $isTopBrandAdmin()) && !$is_PM && !$is_GD">
    <el-dropdown trigger="click" @command="handleCommand">
      <span class="el-dropdown-link"><i class="el-icon-more"></i> </span>

      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item icon="el-icon-edit" command="edit">Edit</el-dropdown-item>
        <el-dropdown-item v-if="!isSimple" icon="el-icon-copy-document" command="copy-to-flight">Copy to flight</el-dropdown-item>
        <el-dropdown-item icon="el-icon-copy-document" command="dublicate">Duplicate</el-dropdown-item>
        <el-dropdown-item icon="el-icon-delete" command="delete">Delete</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>
<script>
import DeleteAsset from '@/components/social-products/social-boost/modal/DeleteAsset.vue'
import CopyToFlight from '../modal/CopyToFlight.vue'
export default {
  name: 'TableAction',
  props: {
    asset: {
      type: [Object, Boolean],
      required: true,
    },
    redirectTo: {
      type: Object,
      default: null,
    },
    isSimple: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handleCommand(command) {
      switch (command) {
        case 'edit':
          this.$router.push({
            name: 'social-boost-edit-asset',
            params: { id: this.$route.params.id, flight_id: this.$route.params.flight_id, asset_id: this.asset.id },
          })
          break
        case 'delete':
          this.$Modal.init(
            {
              propsData: {
                component: DeleteAsset,
                meta: { asset: this.asset, redirectTo: this.redirectTo },
                size: '480px',
              },
              callback(payload) {
                if (payload.event === 'modal:close') {
                }
              },
            },
            this
          )
          break
        case 'copy-to-flight':
          this.$Modal.init(
            {
              propsData: {
                component: CopyToFlight,
                meta: { asset: this.asset },
                size: '480px',
              },
              callback(payload) {
                if (payload.event === 'modal:close') {
                }
              },
            },
            this
          )
          break
        case 'dublicate':
          this.$store.dispatch('socialBoostCampaign/copyAsset', {
            flight_id: this.$route.params.flight_id,
            currentFlight: this.$route.params.flight_id,
            asset_id: this.asset.id,
            asset_name: this.asset.name,
            campaignId: this.$route.params.id,
          })
          break
        default:
          break
      }
    },
  },
}
</script>
